/* eslint-disable */
export default {
  dncAlert: '此联系人位于“谢绝来电”列表中。',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
